import React from 'react';

import {AppContext} from '../../../AppModule/Context';

import HeaderDropDownIcon from '../../../assets/svgComponents/HeaderDropdownIcon';
import LanguageSelectorComponent from './languageSelectorComponent';
import ToolTipComponent from '../../common/genericComponents/toolTipComponent';
import WidgetMentorInfoComponent from './widgetMentorInfoComponent';

import languagesService from '../../../services/languagesService';
import storageService from '../../../services/storageService';
import utilsService from '../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './widgetHeaderComponent.css';

const TOOLTIP_ID = {
  TEAM_CHAT: 'teamChat',
  CLOSE_WIDGET: 'closeWidget',
};
class WidgetHeaderComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      languageLabel: null,
      showTooltipComponent: [],
    };
  }

  componentDidMount = () => {
    if (!this.props.isInAgentList) {
      this.setInitialWidgetLanguage();
    }
  };

  componentDidUpdate = (prevProps) => {
    if (
      this.props.isDemo &&
      !this.props.isInAgentList &&
      prevProps.mentor.mentorDto.uiLanguage !==
        this.props.mentor.mentorDto.uiLanguage &&
      this.props.mentor.mentorDto.uiLanguage
    ) {
      this.setInitialWidgetLanguage();
    }
  };

  setUserLanguage = (currentUser, lang) => {
    this.context.setLanguage(lang);
    console.debug('this is the language in the function --->', lang);
    const languageItem = languagesService.languagesLocaleKeys.find(
      (item) => item.key === lang,
    );
    this.setState({languageLabel: languageItem.value.toUpperCase()});
  };

  setInitialWidgetLanguage = async () => {
    // UI Language priority: localStorage ==> mentor ==> widget ==> "ENGLISH"
    let currentUser = this.context.currentUser;
    const langLocales = languagesService.getLanguagesLocaleKeys();
    const userWidgetLanguage = storageService.getItem('userWidgetLanguage')
      ? JSON.parse(storageService.getItem('userWidgetLanguage'))
      : {};
    const userLanguage =
      userWidgetLanguage[currentUser.userId] ||
      this.props.mentor?.mentorDto?.uiLanguage ||
      this.props.widgetDto.widgetAppCtrlDto.uiLanguage ||
      languagesService.language;
    if (userLanguage) {
      this.setUserLanguage(currentUser, userLanguage.toUpperCase());
      let currentLocal = langLocales.find(({key}) => key === userLanguage);
      if (currentLocal)
        this.setState({languageLabel: currentLocal.value.toUpperCase()});
    } else {
      this.setUserLanguage(currentUser, 'ENGLISH');
    }
  };

  toggleTooltip = (id, enter) => {
    let showTooltipComponent = [...this.state.showTooltipComponent];
    showTooltipComponent[id] = enter;
    this.setState({showTooltipComponent});
  };

  // getLanguages = () => languagesService.getLanguagesLocaleKeys();

  render() {
    const {languageSet, peersStatus} = this.context;
    const {
      canMoveToTeamChat,
      isDemo,
      isEntireWidgetHidden,
      isInAgentList,
      isPersonalPageAndMobile,
      isMultiWidget,
      inTeamChatScenario,
      mentor,
      mentorProfileImage,
      selectedWidgetAppType,
      sessionTemplate,
      widgetDto,
      widgetProfileImage,
      onHeaderBackButton,
      onHeaderCloseButton,
    } = this.props;

    return (
      <div
        className={`et-v2-widget-header-container ${!isInAgentList ? 'et-v2-whc-single-widget-open' : ''}`}>
        <div className="et-v2-whc-bg-pattern-wrap">
          {utilsService.getBgPatternComponentOrName(
            widgetDto.widgetAppCtrlDto.style.bgPatternDto?.patternName,
            widgetDto.widgetAppCtrlDto.style.themePreset,
          )}
        </div>
        <div className="et-v2-widget-header-content-wrap">
          <div className="et-v2-whc-title-close-btn-wrap">
            {!isDemo &&
              !isPersonalPageAndMobile &&
              !isEntireWidgetHidden &&
              !isInAgentList &&
              (!inTeamChatScenario ||
                (inTeamChatScenario &&
                  widgetDto.widgetAppCtrlDto.widgetInteractionMode ===
                    VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.LIST_AND_CHAT)) &&
              (isMultiWidget || canMoveToTeamChat) && (
                <div
                  className="et-v2-whc-back-btn"
                  onClick={() => {
                    onHeaderBackButton();
                  }}
                  onMouseEnter={() => {
                    this.toggleTooltip(TOOLTIP_ID.TEAM_CHAT, true);
                  }}
                  onMouseLeave={() => {
                    this.toggleTooltip(TOOLTIP_ID.TEAM_CHAT, false);
                  }}>
                  <HeaderDropDownIcon
                    fillColor={'var(--et-mentor-cta-primary-btn-text-color)'}
                  />
                  {this.state.showTooltipComponent[TOOLTIP_ID.TEAM_CHAT] && (
                    <ToolTipComponent
                      toolTipArrowStyle={{
                        borderRightColor: 'var(--et-mentor-primary-text-color)',
                      }}
                      toolTipLabelStyle={{
                        background: 'var(--et-mentor-primary-text-color)',
                      }}
                      toolTipTxt={
                        this.props.canMoveToTeamChat
                          ? 'Back to team'
                          : 'Go back'
                      }
                    />
                  )}
                </div>
              )}
            {!isInAgentList && (
              <div className="et-v2-whc-title-txt">
                {mentor.mentorDto.appControlDto?.widgetEditableTexts &&
                mentor.mentorDto.appControlDto?.widgetEditableTexts[
                  selectedWidgetAppType + '_HEADER_TEXT'
                ]
                  ? mentor.mentorDto.appControlDto.widgetEditableTexts[
                      selectedWidgetAppType + '_HEADER_TEXT'
                    ]
                  : languageSet.CONSOLTO_WIDGET
                    ? languageSet.CONSOLTO_WIDGET[
                        selectedWidgetAppType + '_HEADER'
                      ]
                    : VIDABOO_CONSTANTS.CHAT_HEADER[
                        this.props.selectedWidgetAppType
                      ]}
              </div>
            )}
            {!isPersonalPageAndMobile && (
              <div
                className="et-v2-whc-close-btn"
                onClick={isDemo ? null : onHeaderCloseButton}
                onMouseEnter={() => {
                  if (!isDemo) {
                    this.toggleTooltip(TOOLTIP_ID.CLOSE_WIDGET, true);
                  }
                }}
                onMouseLeave={() => {
                  if (!isDemo) {
                    this.toggleTooltip(TOOLTIP_ID.CLOSE_WIDGET, false);
                  }
                }}>
                <HeaderDropDownIcon
                  fillColor={
                    isInAgentList
                      ? 'var(--et-team-secondary-text-color)'
                      : 'var(--et-mentor-cta-primary-btn-text-color)'
                  }
                />
                {this.state.showTooltipComponent[TOOLTIP_ID.CLOSE_WIDGET] && (
                  /* todo 2098 : Ilan : review tooltip text and color */
                  <ToolTipComponent
                    toolTipArrowStyle={{
                      borderLeftColor: 'var(--et-mentor-primary-text-color)',
                    }}
                    toolTipLabelStyle={{
                      background: 'var(--et-mentor-primary-text-color)',
                    }}
                    toolTipPosition="left"
                    toolTipTxt="Close widget"
                  />
                )}
              </div>
            )}
          </div>
          <div className="et-v2-whc-profile-language-selector-wrap">
            <WidgetMentorInfoComponent
              showMentorAvailabilityStatus={
                !isInAgentList &&
                mentor.mentorDto.appControlDto.availabilityBeacon
              }
              displayName={
                isInAgentList
                  ? widgetDto.widgetAppCtrlDto.title
                  : mentor.mentorDto.displayName
              }
              profileImage={
                inTeamChatScenario || isInAgentList
                  ? widgetProfileImage
                  : mentorProfileImage
              }
              sessionTitle={
                isInAgentList
                  ? widgetDto.widgetAppCtrlDto.description
                  : sessionTemplate?.sessionTitle
              }
              peerAvailability={peersStatus[mentor?.mentorDto?.mentorOwnerId]}
            />
            {((isInAgentList &&
              widgetDto.widgetAppCtrlDto?.widgetLanguageSelectorEnabled) ||
              (!isInAgentList &&
                mentor?.mentorDto?.appControlDto
                  ?.widgetLanguageSelectorEnabled)) && (
              <LanguageSelectorComponent props={this.props} />
            )}
          </div>
        </div>
      </div>
    );
  }
}
WidgetHeaderComponent.contextType = AppContext;
export default WidgetHeaderComponent;
